<template>
  <div class="disclaimers">
    <NavBar></NavBar>
    <main
      property="mainContentOfPage"
      class="container"
      typeof="WebPageElement"
    >
      <Breadcrumb></Breadcrumb>
      <section class="custom-section">
        <div class="columns">
          <div class="column is-12">
            <h1 class="title is-2">{{ $t("disclaimer.title") }}</h1>
            <div v-if="$i18n.locale == 'fr'">
              <Avis></Avis>
            </div>
            <div v-else><Terms></Terms></div>
          </div>
        </div>
      </section>
    </main>
    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import BaseFooter from "@/components/Footer.vue";
import Terms from "@/components/TermsAndConditions.vue";
import Avis from "@/components/Avis.vue";
export default {
  name: "disclaimers",
  components: {
    NavBar,
    Breadcrumb,
    BaseFooter,
    Terms,
    Avis
  },
  created() {
    document.title = this.$t("disclaimer.title");
  },
  updated() {
    document.title = this.$t("disclaimer.title");
  }
};
</script>
<style lang="scss">
.address {
  padding: 20px;
}
.terms-list {
  list-style-type: circle;
  padding: 20px;
}
</style>
